import { useMutation } from "@apollo/client";
import { InitiateLoginWithPhoneMutation, InitiateLoginWithPhoneMutationVariables } from "@ctypes";
import { INITIATE_LOGIN_WITH_PHONE } from "@graphql";

export const useInitiateLoginWithPhone = () => {
  return useMutation<InitiateLoginWithPhoneMutation, InitiateLoginWithPhoneMutationVariables>(
    INITIATE_LOGIN_WITH_PHONE,
    {
      context: {
        headers: {
          Authorization: "",
        },
      },
    },
  );
};
